import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => createStyles({
    item: {
        margin: theme.spacing(3),
        maxWidth: '730px',
        textAlign: 'center'
    },
    container: {
        marginTop: theme.spacing(3),
        heigth: '90vh'
    }
}));

export function DashboardLoading() {
    const classes = useStyles();
    
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            justify="center"
            className={classes.container}>
            <Typography variant="h3" className={classes.item}>
                O dashboard está sendo processado...
            </Typography>
            <Typography variant="body1" className={classes.item}> 
                Isso pode levar alguns minutos, por favor não recarregue ou feche a plataforma.
            </Typography>
            <CircularProgress
                color="primary"
                size="124px"
                className={classes.item}/>  
        </Grid>
    );
}